import React from 'react';

const Image = ({ uri }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <img src={uri} alt="Zevi AI" />
    </div>
  );
};

export default Image;
